import { createIcon } from '@/utils/factoryUtil'

export const SVGCommonCrossword = createIcon('SVGCommonCrossword', (props) => (
  <svg viewBox='0 0 100 100' {...props}>
    <path d='M99.5,49.9l-49.38,38.43L.5,50.05,49.6,11.66l49.9,38.24ZM68.13,32.26l-18.54-14.08-18.14,14.13,18.34,14.3,18.34-14.35h0ZM54.34,50.1l18.44,14.15,18.34-14.2-18.54-14.31-18.24,14.36h0ZM68.44,67.54l-18.54-14.08-18.14,14.13,18.34,14.3,18.34-14.35h0Z' />
  </svg>
))
